export enum DriverType {
  DIV = 'division',
  Position = 'position',
  Status = 'active',
  Name = 'firstName'
}
